/* learn-more.js · editorial chronicle page */
(function(){
  if (window.__lmInit) return; window.__lmInit = true;

  var drawers = {};
  var scrim = null;
  var currentKey = null;

  /* -------- relocate drawer elements to <body> so they escape any ancestor
              stacking context / transform that breaks position:fixed -------- */
  function relocateDrawerNodes(){
    var s = document.querySelector('.lm-drawer-scrim');
    if (s && s.parentNode !== document.body) document.body.appendChild(s);
    document.querySelectorAll('.lm-drawer[data-drawer-key]').forEach(function(el){
      if (el.parentNode !== document.body) document.body.appendChild(el);
    });
    var ns = document.querySelector('.lm-navscrim');
    if (ns && ns.parentNode !== document.body) document.body.appendChild(ns);
    var nd = document.querySelector('.lm-navdrawer');
    if (nd && nd.parentNode !== document.body) document.body.appendChild(nd);
  }

  function indexDrawers(){
    drawers = {};
    document.querySelectorAll('.lm-drawer[data-drawer-key]').forEach(function(el){
      drawers[el.dataset.drawerKey] = el;
    });
    scrim = document.querySelector('.lm-drawer-scrim');
  }

  /* -------- chapter observer + rail activation + nav translucent -------- */
  function initChapters(){
    var chapters = document.querySelectorAll('.lm-page section.chapter');
    var railItems = document.querySelectorAll('.lm-page .chapter-rail .item');
    if (chapters.length) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) {
            e.target.classList.add('inview');
            e.target.querySelectorAll('[data-reveal]').forEach(function(el){
              el.classList.add('in');
            });
            var id = e.target.id;
            railItems.forEach(function(r){ r.classList.toggle('active', r.dataset.rail === id); });
          }
        });
      }, { threshold: 0.4 });
      chapters.forEach(function(c){ io.observe(c); });
    }
    var topnav = document.querySelector('.lm-page nav.lm-top');
    if (topnav) {
      function updateNav(){ topnav.classList.toggle('translucent', window.scrollY < 40); }
      window.addEventListener('scroll', updateNav, { passive: true });
      updateNav();
    }
  }

  /* -------- drawer helpers -------- */
  function getPanels(el){ return Array.prototype.slice.call(el.querySelectorAll('.lm-panel:not(.filtered-out)')); }
  function getDots(el){ return Array.prototype.slice.call(el.querySelectorAll('.panel-dots .pd:not(.filtered-out)')); }
  function applyDrawerFilter(el, group){
    var activeGroup = group || '';
    el.dataset.activeGroup = activeGroup;
    el.querySelectorAll('.lm-panel').forEach(function(panel){
      var panelGroup = panel.dataset.panelGroup || '';
      var hide = !!activeGroup && panelGroup !== activeGroup;
      panel.classList.toggle('filtered-out', hide);
      panel.hidden = hide;
    });
    el.querySelectorAll('.panel-dots .pd').forEach(function(dot){
      var dotGroup = dot.dataset.panelGroup || '';
      var hide = !!activeGroup && dotGroup !== activeGroup;
      dot.classList.toggle('filtered-out', hide);
      dot.hidden = hide;
    });
  }
  function currentIdx(el){
    var strip = el.querySelector('.filmstrip');
    var panels = getPanels(el);
    if (!panels.length || !strip) return 0;
    var x = strip.scrollLeft, best = 0, bestD = Infinity;
    panels.forEach(function(p, i){
      var d = Math.abs(p.offsetLeft - x);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }
  function goToPanel(el, i){
    var panels = getPanels(el);
    var strip = el.querySelector('.filmstrip');
    var target = panels[Math.max(0, Math.min(panels.length - 1, i))];
    if (target && strip) strip.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
  }
  function updatePanelState(el){
    var idx = currentIdx(el);
    var dots = getDots(el);
    dots.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
    var prev = el.querySelector('.d-nav.prev');
    var next = el.querySelector('.d-nav.next');
    var panels = getPanels(el);
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= panels.length - 1;
    var strip = el.querySelector('.filmstrip');
    var hint = el.querySelector('.hint');
    if (strip && hint && strip.scrollLeft > 40) hint.classList.add('hidden');
  }

  function openDrawer(key, group){
    var el = drawers[key];
    if (!el || !scrim) return;
    currentKey = key;
    applyDrawerFilter(el, group);
    el.classList.add('open');
    scrim.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lm-drawer-open');
    var strip = el.querySelector('.filmstrip');
    if (strip) strip.scrollLeft = 0;
    updatePanelState(el);
    var hint = el.querySelector('.hint');
    if (hint) hint.classList.remove('hidden');
    el.querySelectorAll('video').forEach(function(v){ try { v.play(); } catch(_){} });
  }
  function closeDrawer(){
    if (!currentKey) return;
    var el = drawers[currentKey];
    if (el) {
      el.classList.remove('open');
      el.setAttribute('aria-hidden', 'true');
      el.querySelectorAll('video').forEach(function(v){ try { v.pause(); } catch(_){} });
    }
    if (scrim) scrim.classList.remove('open');
    document.documentElement.classList.remove('lm-drawer-open');
    currentKey = null;
  }

  /* -------- per-drawer filmstrip scroll/drag wiring -------- */
  function wireDrawer(el){
    if (el.__lmWired) return;
    el.__lmWired = true;
    var strip = el.querySelector('.filmstrip');
    if (!strip) return;
    strip.addEventListener('scroll', function(){ window.requestAnimationFrame(function(){ updatePanelState(el); }); }, { passive: true });
    strip.addEventListener('wheel', function(e){
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        strip.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });
    var drag = null;
    strip.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // don't start a drag when the pointer is on a nav button
      if (e.target.closest('.d-nav') || e.target.closest('.d-close')) return;
      drag = { id: e.pointerId, x: e.clientX, left: strip.scrollLeft, moved: false };
      strip.classList.add('dragging');
    });
    function moveDrag(e){
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) drag.moved = true;
      strip.scrollLeft = drag.left - dx;
    }
    function endDrag(e){
      if (!drag || e.pointerId !== drag.id) return;
      var moved = drag.moved;
      drag = null;
      strip.classList.remove('dragging');
      if (moved) { var idx = currentIdx(el); requestAnimationFrame(function(){ goToPanel(el, idx); }); }
    }
    function clearDrag(){
      drag = null;
      strip.classList.remove('dragging');
    }
    window.addEventListener('pointermove', moveDrag, { passive: true });
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    window.addEventListener('blur', clearDrag);
  }
  function wireAllDrawers(){
    Object.keys(drawers).forEach(function(k){ wireDrawer(drawers[k]); });
  }

  /* -------- mobile nav slide-over -------- */
  function openNav(){
    var d = document.querySelector('.lm-navdrawer');
    var s = document.querySelector('.lm-navscrim');
    var b = document.querySelector('.lm-burger');
    if (!d || !s) return;
    d.classList.add('open'); s.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    if (b) b.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('lm-nav-open');
  }
  function closeNav(){
    var d = document.querySelector('.lm-navdrawer');
    var s = document.querySelector('.lm-navscrim');
    var b = document.querySelector('.lm-burger');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (s) s.classList.remove('open');
    if (b) b.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('lm-nav-open');
  }

  /* -------- global click delegation (works across section re-renders) -------- */
  function initDelegation(){
    if (window.__lmDelegated) return; window.__lmDelegated = true;

    document.addEventListener('click', function(e){
      // burger toggle
      if (e.target.closest('.lm-burger')) {
        e.preventDefault();
        var b = document.querySelector('.lm-burger');
        var isOpen = b && b.getAttribute('aria-expanded') === 'true';
        if (isOpen) closeNav(); else openNav();
        return;
      }
      // nav drawer close / scrim / link click
      if (e.target.closest('.nd-close') || e.target.classList.contains('lm-navscrim')) {
        closeNav();
        return;
      }
      if (e.target.closest('.lm-navdrawer a')) {
        closeNav();
        // let the link proceed normally
      }
      // drawer close
      if (e.target.closest('.lm-drawer .d-close')) {
        e.preventDefault(); e.stopPropagation();
        closeDrawer();
        return;
      }
      // drawer prev/next
      var nav = e.target.closest('.lm-drawer .d-nav');
      if (nav) {
        e.preventDefault(); e.stopPropagation();
        var host = nav.closest('.lm-drawer');
        if (host) goToPanel(host, currentIdx(host) + (nav.classList.contains('next') ? 1 : -1));
        return;
      }
      // scrim dismiss (only when the scrim itself is clicked)
      if (e.target.classList && e.target.classList.contains('lm-drawer-scrim')) {
        closeDrawer();
        return;
      }
      // chapter rail jump
      var rail = e.target.closest('.lm-page .chapter-rail .item');
      if (rail && rail.dataset.rail) {
        e.preventDefault();
        var t = document.getElementById(rail.dataset.rail);
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      // any drawer trigger — but NOT inside a drawer itself (so arrow buttons never re-open)
      var trig = e.target.closest('[data-drawer]');
      if (trig && !e.target.closest('.lm-drawer')) {
        e.preventDefault();
        var key = trig.getAttribute('data-drawer');
        var group = trig.getAttribute('data-drawer-group') || '';
        if (drawers[key]) openDrawer(key, group);
        return;
      }
    });

    document.addEventListener('keydown', function(e){
      // trigger activation on space/enter for pins etc.
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-drawer]') && !e.target.closest('.lm-drawer')) {
        e.preventDefault();
        var key = e.target.getAttribute('data-drawer');
        var group = e.target.getAttribute('data-drawer-group') || '';
        if (drawers[key]) openDrawer(key, group);
        return;
      }
      // Escape closes nav drawer if open (regardless of filmstrip state)
      if (e.key === 'Escape') {
        var nav = document.querySelector('.lm-navdrawer.open');
        if (nav) { e.preventDefault(); return closeNav(); }
      }
      if (!currentKey) return;
      var el = drawers[currentKey];
      if (!el) return;
      if (e.key === 'Escape') { e.preventDefault(); return closeDrawer(); }
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); goToPanel(el, currentIdx(el) + 1); }
      else if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); goToPanel(el, currentIdx(el) - 1); }
      else if (e.key === 'Home') { e.preventDefault(); goToPanel(el, 0); }
      else if (e.key === 'End') { e.preventDefault(); goToPanel(el, getPanels(el).length - 1); }
    });
  }

  function init(){
    relocateDrawerNodes();
    indexDrawers();
    wireAllDrawers();
    initDelegation();
    initChapters();
  }

  // re-run core bits if Shopify theme editor injects/reorders sections
  document.addEventListener('shopify:section:load',   function(){ relocateDrawerNodes(); indexDrawers(); wireAllDrawers(); });
  document.addEventListener('shopify:section:unload', function(){ indexDrawers(); });
  document.addEventListener('shopify:section:select', function(){ relocateDrawerNodes(); indexDrawers(); wireAllDrawers(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
